import { Module } from '@nestjs/common';
import { PersonasModule } from 'src/personas/personas.module';
import { winstonConfig } from '../common/logger/winston.config';
import { ProveedoresController } from './proveedores.controller';
import { ProveedoresService } from './proveedores.service';

@Module({
  controllers: [ProveedoresController],
  providers: [ProveedoresService],
  imports: [PersonasModule],
  exports: [ProveedoresService],
})
export class ProveedoresModule {}
